import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  min-height: 100%;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export const InnerWrapper = styled.div`
  margin-top: -7vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Logo = styled.img`
  width: 35vw;
  max-width: 600px;
  height: auto;
  margin-bottom: 5vh;
`;
